// Planes del criador (misma fuente para la portada /criaderos, el panel y el servidor: breeder.php → BR_PLAN_LIMITS).
export const BREEDER_PRO_MONTHLY = 14990;
export const BREEDER_PRO_YEARLY = 139000;
export const BREEDER_ELITE_MONTHLY = 29990;
export const BREEDER_ELITE_YEARLY = 299000;
export const BREEDER_TRIAL_DAYS = 30;

export const clp = (n: number) => `$${n.toLocaleString('es-CL')}`;

export const FREE_LIMITS = { pets: 8, litters: 1, heats: 2, photos: 5, docs: 3 };
export const PRO_LIMITS = { photos: 20 };

export const FREE_FEATURES = [
    `Hasta ${FREE_LIMITS.pets} ejemplares activos`,
    `${FREE_LIMITS.litters} camada abierta y ${FREE_LIMITS.heats} celos en curso`,
    `${FREE_LIMITS.photos} fotos y ${FREE_LIMITS.docs} documentos por ejemplar`,
    'Carnet sanitario, curva de crecimiento y QR',
    'QR con alerta de escaneo y ubicación',
    'Traspaso digital al comprador',
    'Solicitud de sello de pedigrí',
];

export const PRO_FEATURES = [
    'Ejemplares, camadas y celos ilimitados',
    'Precio de cada ejemplar en tu página pública',
    `${PRO_LIMITS.photos} fotos por ejemplar y documentos ilimitados`,
    'Todo lo del plan Gratis, sin topes',
    `${BREEDER_TRIAL_DAYS} días de prueba al registrar tu criadero`,
];

export const breederMailto = (plan: 'Pro' | 'Élite') => `mailto:hola@amigopeludo.cl?subject=${encodeURIComponent(`Quiero el plan Criador ${plan}`)}&body=${encodeURIComponent(`Hola, quiero activar el plan Criador ${plan} para mi criadero.`)}`;
export const BREEDER_PRO_MAILTO = `mailto:hola@amigopeludo.cl?subject=${encodeURIComponent('Quiero el plan Criador Pro')}&body=${encodeURIComponent('Hola, quiero activar el plan Criador Pro para mi criadero.')}`;

export const ELITE_FEATURES = [
    'Todo lo del plan Pro',
    'Contratos de venta con firma electrónica',
    'Lista de espera de compradores en tu página pública',
    'Aviso por correo cada vez que alguien se anota',
];

// Detalle plan por plan (misma lista para la portada y el panel). true = incluido, false = no, texto = límite.
export type PlanCell = boolean | string;
export const COMPARE_ROWS: { group: string; label: string; free: PlanCell; pro: PlanCell; elite: PlanCell }[] = [
    { group: 'Tu manada', label: 'Ejemplares activos', free: `${FREE_LIMITS.pets}`, pro: 'Ilimitados', elite: 'Ilimitados' },
    { group: 'Tu manada', label: 'Camadas abiertas al mismo tiempo', free: `${FREE_LIMITS.litters}`, pro: 'Ilimitadas', elite: 'Ilimitadas' },
    { group: 'Tu manada', label: 'Celos y gestaciones en curso', free: `${FREE_LIMITS.heats}`, pro: 'Ilimitados', elite: 'Ilimitados' },
    { group: 'Tu manada', label: 'Fotos por ejemplar', free: `${FREE_LIMITS.photos}`, pro: `${PRO_LIMITS.photos}`, elite: `${PRO_LIMITS.photos}` },
    { group: 'Tu manada', label: 'Documentos por ejemplar', free: `${FREE_LIMITS.docs}`, pro: 'Ilimitados', elite: 'Ilimitados' },
    { group: 'Salud e identidad', label: 'Carnet sanitario con alertas y curva de crecimiento', free: true, pro: true, elite: true },
    { group: 'Salud e identidad', label: 'QR por ejemplar con alerta de escaneo y ubicación', free: true, pro: true, elite: true },
    { group: 'Salud e identidad', label: 'Solicitud de sello de pedigrí verificado', free: true, pro: true, elite: true },
    { group: 'Venta y entrega', label: 'Traspaso digital al comprador (con todo su historial)', free: true, pro: true, elite: true },
    { group: 'Venta y entrega', label: 'Página pública con dirección propia', free: true, pro: true, elite: true },
    { group: 'Venta y entrega', label: 'Elegir qué ejemplares se ven en tu página', free: true, pro: true, elite: true },
    { group: 'Venta y entrega', label: 'Precio de cada ejemplar en tu página', free: false, pro: true, elite: true },
    { group: 'Venta y entrega', label: 'Lista de espera de compradores', free: false, pro: false, elite: true },
    { group: 'Venta y entrega', label: 'Contratos de venta con firma electrónica', free: false, pro: false, elite: true },
    { group: 'Venta y entrega', label: 'Aviso por correo cuando alguien se anota', free: false, pro: false, elite: true },
    { group: 'App', label: 'App de Android para criadores', free: true, pro: true, elite: true },
];

// Medios de pago en Chile (el cobro en línea se conecta más adelante; las tarjetas internacionales van aparte).
export const PAYMENT_METHODS = [
    { name: 'Webpay Plus', by: 'Transbank', desc: 'Tarjetas de crédito y débito' },
    { name: 'Mercado Pago', by: '', desc: 'Tarjetas y saldo Mercado Pago' },
    { name: 'Flow', by: '', desc: 'Tarjetas y otros medios de pago locales' },
];